import { cva } from "class-variance-authority";

const controlVariants = cva(
  [
    "m-0 box-border flex h-[44px] items-stretch rounded-[12px] border border-primary-darker-gray bg-primary-white px-[20px] py-[10px] text-start text-base",
    "has-[input:disabled]:bg-primary-gray has-[input:read-only]:bg-primary-gray",
    "has-[input:disabled]:**:data-control-slot:cursor-default has-[input:read-only]:**:data-control-slot:cursor-default",
    "[&_[data-control-slot]+[data-control-slot]]:ml-0 [&_[data-control-slot]+[data-control-slot]]:pr-0 [&_[data-control-slot]+[data-control-slot]]:order-0 [&_[data-control-slot]+[data-control-slot]]:-mr-px [&_[data-control-slot]+[data-control-slot]]:pl-[5px]",
  ],
  {
    variants: {
      error: { true: "border-primary-red" },
      rounded: { true: "rounded-[50px]" },
    },
  },
);

const controlSlotVariants = cva([
  "mr-0 pl-0 order-first -ml-px box-border flex shrink-0 cursor-text items-center pr-[5px] text-primary-dark-gray",
  "data-[side=right]:ml-0 data-[side=right]:pr-0 data-[side=right]:order-0 data-[side=right]:-mr-px data-[side=right]:pl-[5px]",
]);

const controlInputVariants = cva([
  "placeholder:font-light flex w-full cursor-text items-center text-start text-inherit",
  "placeholder:text-primary-dark-gray placeholder:italic",
  "read-only:cursor-default disabled:cursor-default",
]);

export { controlInputVariants, controlSlotVariants, controlVariants };
